const clientPlansPageStyles = {
  pageContainer: {
    width: "100vw",
    minHeight: "100vh",
    padding: "80px 20px",
    background: "#e6f0ff",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mobile: {
      padding: "50px 15px",
    },
  },

  title: {
    fontSize: "2.8rem",
    fontWeight: "700",
    color: "#222",
    marginBottom: "10px",
    mobile: {
      fontSize: "1.5rem",
    },
  },

  subtitle: {
    fontSize: "1.1rem",
    color: "#555",
    marginBottom: "45px",
    mobile: {
      fontSize: "0.85rem",
      marginBottom: "30px",
    },
  },

  planGrid: {
    display: "flex",
    gap: "32px",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%",
    maxWidth: "1400px",
    overflowX: "auto", // allow horizontal scroll on small screens
    paddingBottom: "10px",
    mobile: {
      gap: "20px",
    },
  },

  planCard: {
    background: "#fff",
    borderRadius: "14px",
    padding: "28px",
    width: "320px",
    minWidth: "320px",
    boxShadow: "0 8px 22px rgba(0,0,0,0.08)",
    transition: "all 0.3s ease",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    cursor: "pointer",
    mobile: {
      padding: "20px",
      width: "280px",
      minWidth: "280px",
    },
  },

  planCardHover: {
    transform: "translateY(-8px)",
    boxShadow: "0 14px 30px rgba(0,0,0,0.15)",
  },

  freeBadge: {
    position: "absolute",
    top: "18px",
    right: "18px",
    background: "#28a745",
    color: "#fff",
    padding: "6px 14px",
    fontSize: "0.8rem",
    fontWeight: "600",
    borderRadius: "20px",
    mobile: {
      fontSize: "0.7rem",
      padding: "4px 10px",
    },
  },

  planTypeChip: {
    fontSize: "0.85rem",
    fontWeight: "600",
    padding: "6px 14px",
    borderRadius: "20px",
    marginBottom: "12px",
    mobile: {
      fontSize: "0.75rem",
      padding: "4px 10px",
    },
  },

  planName: {
    fontSize: "1.7rem",
    fontWeight: "700",
    marginBottom: "6px",
    mobile: {
      fontSize: "1.4rem",
    },
  },

  planDescription: {
    fontSize: "0.95rem",
    color: "#666",
    marginBottom: "18px",
    minHeight: "40px",
    mobile: {
      fontSize: "0.85rem",
      marginBottom: "12px",
    },
  },

  priceSection: {
    fontSize: "2.6rem",
    fontWeight: "700",
    marginBottom: "4px",
    mobile: {
      fontSize: "2rem",
    },
  },

  perPlanText: {
    fontSize: "0.95rem",
    color: "#777",
    marginBottom: "20px",
    mobile: {
      fontSize: "0.85rem",
      marginBottom: "15px",
    },
  },

  featuresList: {
    listStyle: "none",
    padding: 0,
    width: "100%",
    marginBottom: "22px",
    mobile: {
      marginBottom: "15px",
    },
  },

  featureItem: {
    fontSize: "0.95rem",
    padding: "8px 0",
    borderBottom: "1px solid #eee",
    color: "#444",
    textAlign: "left",
    mobile: {
      fontSize: "0.85rem",
      padding: "6px 0",
    },
  },

  button: {
    width: "100%",
    padding: "14px",
    fontSize: "1.05rem",
    fontWeight: "700",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    color: "#fff",
    transition: "filter 0.2s ease",
    mobile: {
      fontSize: "0.95rem",
      padding: "12px",
    },
  },
};

export default clientPlansPageStyles;
